import { Component } from '@angular/core';
import { MaterialModule } from '@ukam/ui-kit/material.module';
import { AppStoredFileFinderListComponent } from './list/list.component';

@Component({
  selector: 'app-stored-file-finder',
  templateUrl: './stored-file-finder.component.html',
  imports: [MaterialModule, AppStoredFileFinderListComponent],
})
export class AppStoredFileFinderComponent { }
